import * as React from "react";
import {Button, Modal} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import {WithApi, WithApiProperties} from "../../util/WithApi";
import {ErrorDisplay} from "../errordisplay/ErrorDisplay";
import {
  ChooseFileForm,
  ChooseFileFormItem,
  ChooseFileFormSourceType,
  ChooseMode,
  ItemType,
  MultiHandleChoose,
  SingleHandleChoose
} from "./ChooseFileForm";

interface ChooseFileDialogProps {
  source?: ChooseFileFormSourceType;
  chooseMode: ChooseMode;
  show: boolean;
  onHide: () => void;
  initialPath?: string;
  title: string;
  buttonText: string;
  onChoosed: () => void;
  canMultiSelect?: boolean;
  handleChoose?: SingleHandleChoose;
  handleMultiChoose?: MultiHandleChoose;
  fileFilters?: string[];
  fileFiltersActive?: string[];
  fileFiltersEnabled?: boolean;
}

interface ChooseFileDialogState {
  isLoading: boolean;
  success: boolean;
  error: Error;
}

class ChooseFileDialogComponent extends React.Component<ChooseFileDialogProps & WithApiProperties, ChooseFileDialogState> {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      success: false,
      error: null,
    };
  }

  private chooseFile = (path: string, type: ItemType) => {
    return this.choose(this.props.handleChoose(path, type));
  }

  private chooseMultiFile = (items: ChooseFileFormItem[]) => {
    return this.choose(this.props.handleMultiChoose(items));
  }

  private choose = (choosePromise: Promise<any>) => {
    this.setState({isLoading: true});
    return choosePromise
        .then(() => {
          this.setState({isLoading: false, success: true});
          this.props.onChoosed();
        }).catch(
            (error) => {
              this.setState({isLoading: false, error});
            },
        );
  }

  resetState = () => {
    this.setState({isLoading: false, success: false, error: null});
  }

  render() {
    const {show, onHide, initialPath, title, buttonText, canMultiSelect} = this.props;
    const {isLoading, success, error} = this.state;
    let pageMainContent, buttons = null;
    if (!isLoading && error) {
      pageMainContent = (
          <div>
            <ErrorDisplay error={error}/>
          </div>
      );
      buttons = <Button onClick={this.resetState}> <FormattedMessage id="studio.choose-folder-dialog.try-again"
                                                                     defaultMessage="Try again"/> </Button>;
    } else if (!isLoading && success) {
      pageMainContent = (
          <div>
            <p><FormattedMessage id="studio.choose-folder-dialog.add-success"
                                 defaultMessage="Successfully selected folder."/></p>
          </div>
      );
      buttons = (
          <Button onClick={onHide}> <FormattedMessage id="studio.choose-folder-dialog.close"
                                                      defaultMessage="Close"/></Button>
      );
    } else if (isLoading) {
      pageMainContent = <p><FormattedMessage id="studio.choose-folder-dialog.adding"
                                             defaultMessage="Loading..."/></p>;
    } else {
      pageMainContent = <ChooseFileForm
          source={this.props.source}
          chooseMode={this.props.chooseMode}
          fileFilters={this.props.fileFilters}
          fileFiltersActive={this.props.fileFiltersActive}
          fileFiltersEnabled={this.props.fileFiltersEnabled}
          canMultiSelect={canMultiSelect}
          handleChoose={this.chooseFile}
          handleMultiChoose={this.chooseMultiFile}
          initialPath={initialPath}
          buttonText={buttonText}/>;
    }

    const footer = buttons ? (<Modal.Footer>{buttons}</Modal.Footer>) : null;

    return (
        <div>
          <Modal show={show} onHide={onHide} onExited={this.resetState} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {pageMainContent}
            </Modal.Body>
            {footer}
          </Modal>
        </div>
    );
  }

}

export const ChooseFileDialog = WithApi(ChooseFileDialogComponent)